module.exports = __webpack_public_path__ + "img/our-story2.f74cc536.jpg";